/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { HelpModalComponentArgs } from 'cio/components/help-modal';

export default class FeedbackForm extends Component<HelpModalComponentArgs> {
  // Internal API
  criticism = null;
  praise = null;

  // Disable the form if the comment or goal fields are empty
  @computed('criticism', 'praise')
  get isDisabled() {
    return isEmpty(this.criticism) && isEmpty(this.praise);
  }

  @action
  submitAction(e: SubmitEvent) {
    e.preventDefault();

    let { criticism, praise } = this;
    this.args.onSubmit({ criticism, praise });
  }
}
